import { useState } from 'react'
import { MoreVert } from '@mui/icons-material'
import { ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { MoreMenuItems } from 'pages/datasets/types'
import * as css from './styles'

interface Props {
  datasetId: number
  menuItems: MoreMenuItems
}

export const More = ({ datasetId, menuItems }: Props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  function handleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  function onClose() {
    setAnchorEl(null)
  }

  if (!menuItems.length) return null

  return (
    <>
      <css.ButtonWithIcon
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        css={open && css.hoverHighlight}
      >
        <MoreVert />
      </css.ButtonWithIcon>
      <Menu
        open={open}
        id="more-button"
        onClose={onClose}
        anchorEl={anchorEl}
        css={css.menu}
        elevation={3}
      >
        {menuItems.map(({ Icon, name, createLink, callback = null }) => {
          if (typeof createLink === 'function') {
            return (
              <Link
                key={name}
                to={createLink(datasetId)}
                onClick={() => {
                  callback?.()
                }}
              >
                <MenuItem css={css.menuItem}>
                  {Icon && (
                    <ListItemIcon style={{ minWidth: 30 }}>
                      <Icon />
                    </ListItemIcon>
                  )}
                  <ListItemText primary={<Typography css={css.typography}>{name}</Typography>} />
                </MenuItem>
              </Link>
            )
          }

          if (typeof callback === 'function') {
            return (
              <a
                key={name}
                onClick={() => {
                  callback()
                }}
              >
                <MenuItem css={css.menuItem}>
                  {Icon && (
                    <ListItemIcon style={{ minWidth: 30 }}>
                      <Icon />
                    </ListItemIcon>
                  )}
                  <ListItemText primary={<Typography css={css.typography}>{name}</Typography>} />
                </MenuItem>
              </a>
            )
          }
        })}
      </Menu>
    </>
  )
}
